// extracted by mini-css-extract-plugin
export default {"container":"ItemsComparison-module_container__s6RN5","separator":"ItemsComparison-module_separator__tmAqU"};